import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[92vh] flex items-center justify-center px-6 md:px-12 pt-32 pb-24">
      <div aria-hidden className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute left-1/2 top-1/3 -translate-x-1/2 -translate-y-1/2 w-[1100px] h-[700px] rounded-full opacity-[0.85] warm-halo" />
      </div>
      <div className="max-w-5xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.05, ease: [0.16, 1, 0.3, 1] }}
          className="overline mb-8"
          data-testid="hero-overline"
        >
          The autonomous ChipOps platform
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-[2.5rem] sm:text-5xl md:text-6xl lg:text-[4.75rem] leading-[1.05] tracking-tight text-strong font-medium"
          data-testid="hero-headline"
        >
          <span className="serif-italic text-accent">Streamlined</span> ChipOps Platform —{" "}
          <br className="hidden md:block" />
          from Planning to Signoff.
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="mt-8 md:mt-10 text-lg md:text-xl text-muted max-w-2xl mx-auto leading-relaxed font-body"
          data-testid="hero-sub"
        >
          Built on rigorous methodology, optimized flows, and integrated quality management — powered quietly by AI.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.55, ease: [0.16, 1, 0.3, 1] }}
          className="mt-12 flex items-center justify-center gap-4 flex-wrap"
        >
          <a href="#contact" data-testid="hero-cta" className="btn-primary">
            Talk to us <span aria-hidden>→</span>
          </a>
          <a href="#problems" data-testid="hero-secondary" className="text-sm text-muted hover:text-strong transition-colors px-5 py-3">
            Where chip teams lose time
          </a>
        </motion.div>
      </div>
    </section>
  );
}
